module.exports = __webpack_public_path__ + "bradavice_4_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/bradavice_4_before_tn.jpg
// module id = 1404
// module chunks = 0